export default () => {
  window.zE('webWidget', 'show');
};
